import request from '@/utils/request'

let PointsreleaseApi = {
    /*列表*/
    getProduct(data) {
        return request._get('/shop/plus.pointsrelease.product/index', data);
    },
    getRelease(data) {
        return request._get('/shop/plus.pointsrelease.product/release', data);
    },
    getLog(data) {
        return request._get('/shop/plus.pointsrelease.product/log', data);
    },
    /*添加*/
    addProduct(data) {
        return request._post('/shop/plus.pointsrelease.product/add', data);
    },
    /*编辑*/
    editProduct(data) {
        return request._post('/shop/plus.pointsrelease.product/edit', data);
    },
    /*删除*/
    delProduct(data) {
        return request._post('/shop/plus.pointsrelease.product/delete', data);
    },
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.pointsrelease.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.pointsrelease.setting/index', data);
    },

}

export default PointsreleaseApi;



// WEBPACK FOOTER //
// ./src/api/pointsrelease.js